export default "__VITE_ASSET__CsO6ZOvm__"